import React, {useEffect, useState} from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Navigate, useParams } from 'react-router-dom'
import { ApiUrl, Headers } from '../services/ApiUrl';
import axios from 'axios'
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import ListGroup from 'react-bootstrap/ListGroup';
import Badge from 'react-bootstrap/Badge';
import Accordion from 'react-bootstrap/Accordion';
import Alert from 'react-bootstrap/Alert';
import Spinner from 'react-bootstrap/Spinner';

const Parrafolinea = ({titulo, contenido}) =>{
 
  return <p style={{whiteSpace: 'pre-line'}}>
  <strong>{titulo}: </strong><br/>
  {contenido}
</p>    
  
}

const DetalleProyectos = ({userAdmin, user}) => {
    const[idProyecto, setIdProyecto] = useState(0)
    const[detalleProyecto, setDetalleProyecto]= useState([])
    const[loadingDetalleProyecto, setLoadingDetalleProyecto]= useState(false)
    let {id} = useParams();



    const cargarProyectoDetalle =(id)=>{
      setLoadingDetalleProyecto(true)
      let url = ApiUrl + `relations?rel=users_proyectos,pp2023_proyectos&type=,user&select=*&linkTo=id_proyecto&equalTo=${id}`
      axios.get(url, {headers:Headers})
      .then( response =>{
        setDetalleProyecto(response.data.results[0])
              //console.log(response)        

      }).catch( error=>{
        setDetalleProyecto([])
          //console.log(error)

      })
      .finally(function () {
          setLoadingDetalleProyecto(false)
      
      });         
  }    
  
   

    useEffect(() => {
      setIdProyecto(`${id}`)
      cargarProyectoDetalle(`${id}`)
    },[]);    
  return (


     
    <>
    {userAdmin.login ===false && user.login===false &&
        <Navigate to="/iniciarsesionadmin" />
    }    
    {(userAdmin.login ===true || user.id_user == detalleProyecto.id_user) &&   
    <>     
    <Container>
        <Row>
            <Col>
                <h1>Detalle proyecto #{idProyecto}</h1>
                    {loadingDetalleProyecto &&
                        <Spinner animation="border" role="status">
                            <span className="visually-hidden">Cargando...</span>
                        </Spinner>                
                    }                                         
            </Col>
        </Row>
      </Container>
      <Container>
          <Row>
              {!loadingDetalleProyecto &&
              <Col style={{marginTop:'30px'}}>                                      
                <Card>
                  {(detalleProyecto.imagen_destacada !=="" && detalleProyecto.imagen_destacada !== null) ?
                  <Card.Img variant="top" fluid='true'  src={`https://trenquelauquen.gov.ar/public/pp2023/uploads/${detalleProyecto.imagen_destacada}`} 
                  style={{width: '500px'}} />
                  : 
                  <Card.Img variant="top" fluid='true'  src="https://trenquelauquen.gov.ar/public/pp2023/uploads/default-image.jpg" 
                  style={{width: '500px'}} />                                                                              
                  }
                  <Card.Body>
                    <Card.Title style={{minHeight:'50px'}}> {detalleProyecto.titulo_proyecto} <span> </span>
                      {detalleProyecto.estado ==="Borrador" && <Badge bg="warning" text="dark">Borrador</Badge>}
                      {detalleProyecto.estado ==="Presentado" && <Badge bg="success">Presentado</Badge>}
                    </Card.Title>

                    {detalleProyecto.estado ==="Borrador" &&
                      <Alert variant="warning">
                        Fecha de última actualización: {detalleProyecto.fecha_borrador}
                      </Alert>
                    }
                    {detalleProyecto.estado ==="Presentado" &&
                      <Alert variant="success">
                        Fecha de presentación: {detalleProyecto.fecha_entrega}
                      </Alert>
                    }



                    <ListGroup style={{fontSize:'18px'}}>                                                        
                      <ListGroup.Item ><strong>Categoría:</strong> {detalleProyecto.categoria_proyecto}</ListGroup.Item>
                      <ListGroup.Item > 
                        <Parrafolinea titulo="Descripción" contenido={detalleProyecto.descripcion_proyecto} />                     
                      </ListGroup.Item >
                      <ListGroup.Item ><i className="bi bi-geo-alt"></i> {detalleProyecto.localidad_proyecto}</ListGroup.Item>
                      <ListGroup.Item><i className="bi bi-currency-dollar"></i> {detalleProyecto.monto_total_estimado}</ListGroup.Item>
                    </ListGroup>

                                                    
                    <Accordion defaultActiveKey="0">
                      <Accordion.Item eventKey="0">
                      <Accordion.Header><span  style={{fontSize:'20px'}}><i className="bi bi-person-fill-add"> </i> {detalleProyecto.name_user}</span> </Accordion.Header>
                      <Accordion.Body>
                        <p style={{fontSize:'18px'}}><i className="bi bi-person-vcard"></i> {detalleProyecto.dni}</p>
                        <p style={{fontSize:'18px'}}><i className="bi bi-envelope-at"></i> {detalleProyecto.email_user}</p>
                        <p style={{fontSize:'18px'}}><i className="bi bi-phone"></i> {detalleProyecto.telefono}</p>
                                                              
                      </Accordion.Body>
                      </Accordion.Item>
                      </Accordion> 
                      <Accordion defaultActiveKey="0">                      
                      <Accordion.Item eventKey="0">
                      <Accordion.Header><span  style={{fontSize:'20px'}}><i className="bi bi-person-fill-add"> </i> Avales</span> </Accordion.Header>
                      <Accordion.Body>
                      <ListGroup  style={{fontSize:'18px'}}>                                                        
                      <ListGroup.Item ><i className="bi bi-person-fill"></i> {detalleProyecto.aval1_nombre} | <i className="bi bi-person-vcard"></i> {detalleProyecto.aval1_dni}</ListGroup.Item>
                      <ListGroup.Item ><i className="bi bi-person-fill"></i> {detalleProyecto.aval2_nombre} | <i className="bi bi-person-vcard"></i> {detalleProyecto.aval2_dni}</ListGroup.Item>
                      <ListGroup.Item ><i className="bi bi-person-fill"></i> {detalleProyecto.aval3_nombre} | <i className="bi bi-person-vcard"></i> {detalleProyecto.aval3_dni}</ListGroup.Item>
                      <ListGroup.Item ><i className="bi bi-person-fill"></i> {detalleProyecto.aval4_nombre} | <i className="bi bi-person-vcard"></i> {detalleProyecto.aval4_dni}</ListGroup.Item>
                      <ListGroup.Item ><i className="bi bi-person-fill"></i> {detalleProyecto.aval5_nombre} | <i className="bi bi-person-vcard"></i> {detalleProyecto.aval5_dni}</ListGroup.Item>
                      
                      </ListGroup>                        
                                                            
                      </Accordion.Body>
                      </Accordion.Item>                      
                    </Accordion>                                                    

                    <ListGroup style={{fontSize:'18px'}}>
                      <ListGroup.Item ><strong>Beneficiarios / destinatarios:</strong> {detalleProyecto.beneficiarios_destinatarios}</ListGroup.Item>
                      <ListGroup.Item><strong>Tipo de proyecto:</strong> {detalleProyecto.tipo_proyecto} </ListGroup.Item>
                      <ListGroup.Item><strong>Nombre del grupo:</strong> {detalleProyecto.nombre_grupo} </ListGroup.Item>  
                      <ListGroup.Item > 
                        <Parrafolinea titulo="Objetivo general" contenido={detalleProyecto.objetivo_general} />                     
                      </ListGroup.Item >                      
                      <ListGroup.Item > 
                        <Parrafolinea titulo="Objetivos específicos" contenido={detalleProyecto.objetivos_especificos} />                     
                      </ListGroup.Item > 

                      <ListGroup.Item > 
                        <Parrafolinea titulo="Antecedentes / fundamentación" contenido={detalleProyecto.antecedentes_fundamentacion} />                     
                      </ListGroup.Item > 
                      
                      <ListGroup.Item > 
                        <Parrafolinea titulo="Localización" contenido={detalleProyecto.localizacion} />                     
                      </ListGroup.Item >                       
                      
                      <ListGroup.Item > 
                        <Parrafolinea titulo="Acciones y tareas" contenido={detalleProyecto.acciones_y_tareas} />                     
                      </ListGroup.Item >                       

                      <ListGroup.Item > 
                        <Parrafolinea titulo="Recursos humanos" contenido={detalleProyecto.recursos_humanos} />                     
                      </ListGroup.Item >   

                      <ListGroup.Item > 
                        <Parrafolinea titulo="Recursos materiales" contenido={detalleProyecto.recursos_materiales} />                     
                      </ListGroup.Item >  

                      <ListGroup.Item > 
                        <Parrafolinea titulo="Recursos financieros" contenido={detalleProyecto.recursos_financieros} />                     
                      </ListGroup.Item >  

                      <ListGroup.Item>
                      {detalleProyecto.imagen1_url !=="" && detalleProyecto.imagen1_url !==null && 
                      <img src={`https://trenquelauquen.gov.ar/public/pp2023/uploads/${detalleProyecto.imagen1_url}`} width={400} />
                      }
                      <p>{detalleProyecto.imagen1_nombre}</p>
                      </ListGroup.Item>

                      <ListGroup.Item>
                      {detalleProyecto.imagen2_url !=="" && detalleProyecto.imagen2_url !==null && 
                      <img src={`https://trenquelauquen.gov.ar/public/pp2023/uploads/${detalleProyecto.imagen2_url}`} width={400} />
                      }
                      <p>{detalleProyecto.imagen2_nombre}</p>
                      </ListGroup.Item>

                      <ListGroup.Item>
                      {detalleProyecto.imagen3_url !=="" && detalleProyecto.imagen3_url !==null && 
                      <img src={`https://trenquelauquen.gov.ar/public/pp2023/uploads/${detalleProyecto.imagen3_url}`} width={400} />
                      }
                      <p>{detalleProyecto.imagen3_nombre}</p>
                      </ListGroup.Item>

                      <ListGroup.Item>
                      {detalleProyecto.documento_pdf !=="" && detalleProyecto.documento_pdf !==null && 
                      <Button style={{marginTop:'10px',marginBottom:'10px'}} href={`https://trenquelauquen.gov.ar/public/pp2023/uploads/${detalleProyecto.documento_pdf}`} variant='outline-success' target='_blank'><i className="bi bi-file-earmark-pdf"></i> Visualizar documento</Button>
                      }
                      <p>{detalleProyecto.documento_nombre}</p>
                      </ListGroup.Item>

                    </ListGroup> 
                    
                                                                       

                  </Card.Body>                                           
                </Card>
              </Col>  
                                }        
        </Row>
    </Container> 
    </>
        }                                   
    </>

  )
}

export default DetalleProyectos